function initProductContentProp65WarningAccordion(container) {
  const $prop65WarningDetailsList = container.querySelectorAll('.system-subitem');

  $prop65WarningDetailsList.forEach(($prop65WarningDetails) => {
    const $prop65WarningSummary = $prop65WarningDetails.querySelector('.system-subitem-title');
    const $prop65WarningContent = $prop65WarningDetails.querySelector('.system-subitem-content');
    let prop65WarningAnimation = null;
    let isProp65WarningClosing = false;
    let isProp65WarningExpanding = false;

    const onProp65WarningAnimationFinish = (open) => {
      $prop65WarningDetails.open = open;
      $prop65WarningSummary.setAttribute('aria-expanded', open ? 'true' : 'false');
      prop65WarningAnimation = null;
      isProp65WarningClosing = false;
      isProp65WarningExpanding = false;
      $prop65WarningDetails.style.height = '';
      $prop65WarningDetails.style.overflow = '';
    };

    const shrinkProp65Warning = () => {
      isProp65WarningClosing = true;
      const startHeight = `${$prop65WarningDetails.offsetHeight}px`;
      const endHeight = `${$prop65WarningSummary.offsetHeight}px`;

      if (prop65WarningAnimation) prop65WarningAnimation.cancel();
      prop65WarningAnimation = $prop65WarningDetails.animate(
        { height: [startHeight, endHeight] },
        { duration: 300, easing: 'ease-out' }
      );
      prop65WarningAnimation.onfinish = () => onProp65WarningAnimationFinish(false);
      prop65WarningAnimation.oncancel = () => {
        isProp65WarningClosing = false;
      };
    };

    const expandProp65Warning = () => {
      isProp65WarningExpanding = true;
      const startHeight = `${$prop65WarningDetails.offsetHeight}px`;
      const endHeight = `${$prop65WarningSummary.offsetHeight + $prop65WarningContent.offsetHeight}px`;

      if (prop65WarningAnimation) prop65WarningAnimation.cancel();
      prop65WarningAnimation = $prop65WarningDetails.animate(
        { height: [startHeight, endHeight] },
        { duration: 300, easing: 'ease-out' }
      );
      prop65WarningAnimation.onfinish = () => onProp65WarningAnimationFinish(true);
      prop65WarningAnimation.oncancel = () => {
        isProp65WarningExpanding = false;
      };
    };

    const openProp65Warning = () => {
      $prop65WarningDetails.style.height = `${$prop65WarningDetails.offsetHeight}px`;
      $prop65WarningDetails.open = true;
      $prop65WarningSummary.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(expandProp65Warning);
    };

    $prop65WarningSummary.addEventListener('click', (event) => {
      event.preventDefault();
      $prop65WarningDetails.style.overflow = 'hidden';

      if (isProp65WarningClosing || !$prop65WarningDetails.open) {
        openProp65Warning();
      } else if (isProp65WarningExpanding || $prop65WarningDetails.open) {
        shrinkProp65Warning();
      }
    });
  });
}

function initProductContentSection(event) {
  const container = event && event.target ? event.target : document;
  initProductContentProp65WarningAccordion(container);
}

document.addEventListener('DOMContentLoaded', () => initProductContentSection());
document.addEventListener('shopify:section:load', initProductContentSection);
